module.exports = __webpack_public_path__ + "img/drag-sorting-icon.ced7af9b.svg";